export default "__VITE_ASSET__68ab12cf__"